import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Reusable gradient call-to-action band used at the bottom of pages.
 */
const CTASection = ({
  title = "Ready to Build the Future?",
  text = "Whether you're launching an AI-powered product, modernizing legacy systems, or scaling cloud infrastructure, Triguna Solutions is ready to help.",
  buttonLabel = "Book a Free Consultation",
  to = "/contact",
}) => {
  const navigate = useNavigate();

  return (
    <section className="px-4 py-20 sm:py-24">
      <div className="relative mx-auto max-w-6xl overflow-hidden rounded-3xl bg-brand-gradient px-6 py-16 text-center sm:px-12">
        {/* ambient blobs */}
        <div className="pointer-events-none absolute -left-20 -top-20 h-64 w-64 rounded-full bg-white/10 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-24 -right-16 h-72 w-72 rounded-full bg-fuchsia-400/25 blur-3xl" />

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative"
        >
          <h2 className="font-display text-3xl font-bold text-white sm:text-4xl lg:text-5xl">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-purple-50/90 sm:text-lg">
            {text}
          </p>
          <motion.button
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.96 }}
            onClick={() => navigate(to)}
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-base font-semibold text-brand-navy shadow-lg transition-shadow hover:shadow-xl"
          >
            {buttonLabel}
            <ArrowRight className="h-5 w-5" />
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
